import { render, staticRenderFns } from "./Retpassword.vue?vue&type=template&id=25a7cc49&scoped=true&"
import script from "./Retpassword.vue?vue&type=script&lang=js&"
export * from "./Retpassword.vue?vue&type=script&lang=js&"
import style0 from "./Retpassword.vue?vue&type=style&index=0&id=25a7cc49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a7cc49",
  null
  
)

export default component.exports